import _ from '../../core/utils'
import REFRESH_CONFIG from "./config"

class RefreshClass {
    constructor() {
        this.DOM = {
            el: REFRESH_CONFIG.el
        }

        this.DOM.el ? this.init() : null
    }

    init() {
        this._listeners()
    }

    _listeners() {
        this.DOM.el.addEventListener( 'click', this._refresh.bind( this ) )
    }

    _refresh() {
        window.location.reload()
    }
}

const REFRESH = new RefreshClass()
export default REFRESH